import React from 'react';

export default function StatCard({ icon, label, value, caption, accent = 'blue', onClick }) {
  return (
    <button type="button" className={`stat-card accent-${accent}`} onClick={onClick} disabled={!onClick}>
      <div className="stat-card-top">
        <span className="stat-pod">{icon}</span>
        <span className="live-pill">● LIVE</span>
      </div>
      <span className="stat-label">{label}</span>
      <strong>{value}</strong>
      <small>{caption || 'Live database count'}</small>
      <span className="stat-arrow">→</span>
    </button>
  );
}
